


















import {
  computed,
  defineComponent,
  onUnmounted,
  PropType,
  provide,
  useSlots
} from '@vue/composition-api';
import WorkflowViewport from './WorkflowViewport.vue';
import WorkflowBackground from '../components/WorkflowBackground.vue';

import { useWorkFlow } from '../composables/useWorkFlow';
import { useWatchProps } from '../composables';
import { useHooks } from '../store';
import { useOnInitHandler } from '../composables/useOnInitHandler';
import NodeRenderer from './NodeRenderer/NodeRenderer.vue';
import EdgeRenderer from './EdgeRenderer/EdgeRenderer.vue';
import { Slots } from '../context';
import { FlowSlots, Edge, Node, FlowProps } from '../types';
import { IWorkflowState, IWorkflowTransition } from '@/models';

export default defineComponent<FlowProps>({
  name: 'WorkflowCanvas',

  components: {
    EdgeRenderer,
    NodeRenderer,
    WorkflowBackground,
    WorkflowViewport
  },

  props: {
    nodes: {
      type: Array as PropType<Node<IWorkflowState>[]>,
      default: () => []
    },
    edges: {
      type: Array as PropType<Edge<IWorkflowTransition>[]>,
      default: () => []
    },
    panOnDrag: {
      type: [Array, Boolean] as PropType<number[] | boolean>,
      default: true
    },
    connectOnClick: {
      type: Boolean
    },
    applyDefault: {
      type: Boolean,
      default: true
    },
    snapGrid: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean
    }
  },

  setup(props, { emit }) {
    const instance = useWorkFlow(props);

    const modelNodes = computed({
      get(): Node<IWorkflowState>[] {
        return props.nodes!;
      },
      set(nodes: Node<IWorkflowState>[]) {
        emit('update:nodes', nodes);
      }
    });

    const modelEdges = computed({
      get(): Edge<IWorkflowTransition>[] {
        return props.edges!;
      },
      set(edges: Edge<IWorkflowTransition>[]) {
        emit('update:edges', edges);
      }
    });
    // watch props and update store state
    const dispose = useWatchProps(
      {
        nodes: modelNodes,
        edges: modelEdges
      },
      props,
      instance
    );

    useHooks(emit, instance.hooks);

    useOnInitHandler();

    const slots = useSlots() as Readonly<FlowSlots>;

    // slots will be passed via provide
    // this is to avoid having to pass them down through all the components
    // as that would require a lot of boilerplate and causes significant performance drops
    provide(Slots, slots);

    onUnmounted(() => {
      // clean up watcher scope
      dispose();
    });

    return {
      workFlowRef: instance.workFlowRef
    };
  }
});
